import { RoomProvider, ClientSideSuspense } from '@liveblocks/react/suspense'
import { FeatureDict, selectFeatureIncludes } from '@authed/selectors'
import { Loader } from '@components'
import { useAppSelector } from '@redux/hooks'
import { LiveblocksEditList } from './liveblocks-edit-list'
import { EditList } from './edit-list'

export const EditListRoute = () => {
  const [ENABLE_LIVEBLOCKS = false] = useAppSelector(
    selectFeatureIncludes([FeatureDict.ENABLE_LIVEBLOCKS]),
  )
  const { uuid: accountUuid } = useAppSelector(state => state.Auth.account)
  const isNewList = window.location.pathname.split('/').pop() === 'new'

  return ENABLE_LIVEBLOCKS && !isNewList && accountUuid ? (
    <RoomProvider
      id={`accountUuid:${accountUuid}:list:${window.location.pathname.split('/').pop() ?? 'default'}`}
      initialStorage={{
        lock: null,
      }}
    >
      <ClientSideSuspense fallback={<Loader />}>
        <LiveblocksEditList />
      </ClientSideSuspense>
    </RoomProvider>
  ) : (
    <EditList />
  )
}
